export default __webpack_public_path__ + "static/media/Kronenpinguin.df31a73b.jpg";